<div class="app-workflow full-height">
	<div class="box-header d-flex align-items-center">
		<!-- <div class="d-flex align-items-center">
			<i class="fa fa-bars" aria-hidden="true"></i>
		</div> -->
		<div class="workflow-topbar">
			<p class="workflow-title">{{ "WORKFLOW.TITLE" | translate }}</p>
			<div *ngIf="alarm && !workflowComplete" class="workflow-actions" role="toolbar"
				[attr.aria-label]="'WORKFLOW.TITLE' | translate">
				<button type="button" class="workflow-action-btn" [class.active-link]="isSendMailBoxShown"
					[attr.aria-pressed]="isSendMailBoxShown" [attr.aria-label]="'WORKFLOW.SEND_MAIL' | translate"
					[title]="'WORKFLOW.SEND_MAIL' | translate" (click)="showSendMailBox()">
					<i class="fa fa-envelope" aria-hidden="true"></i>
				</button>
				<button type="button" class="workflow-action-btn" [class.active-link]="isCommentBoxShown"
					[attr.aria-pressed]="isCommentBoxShown" [attr.aria-label]="'WORKFLOW.ADD_COMMENT' | translate"
					[title]="'WORKFLOW.ADD_COMMENT' | translate" (click)="showCommentBox()">
					<i class="fa fa-comment-o" aria-hidden="true"></i>
				</button>
				<button type="button" class="workflow-action-btn" *ngIf="alarm.status != EscalatedAlarm"
					[class.active-link]="isEscalationConfirmationShown" [attr.aria-pressed]="isEscalationConfirmationShown"
					[attr.aria-label]="'WORKFLOW.ESCALATE_ALARM' | translate" [title]="'WORKFLOW.ESCALATE_ALARM' | translate"
					(click)="showEscalationConfirmation()">
					<i class="fa fa-external-link" aria-hidden="true"></i>
				</button>
				<button type="button" class="workflow-action-btn" [class.active-link]="isChatShown"
					[attr.aria-pressed]="isChatShown" [attr.aria-label]="'WORKFLOW.CHAT' | translate"
					[title]="'WORKFLOW.CHAT' | translate" (click)="showChatBox()">
					<i class="fa fa-comments" aria-hidden="true"></i>
				</button>
				<button type="button" class="workflow-action-btn" [class.workflow-action-btn--muted]="!speechService.allowAudio"
					[attr.aria-pressed]="speechService.allowAudio"
					[attr.aria-label]="(speechService.allowAudio ? 'WORKFLOW.MUTE_AUDIO' : 'WORKFLOW.ENABLE_AUDIO') | translate"
					[title]="(speechService.allowAudio ? 'WORKFLOW.MUTE_AUDIO' : 'WORKFLOW.ENABLE_AUDIO') | translate"
					(click)="toggleAudio()">
					<i class="fa" [ngClass]="speechService.allowAudio ? 'fa-volume-up' : 'fa-volume-off'" aria-hidden="true"></i>
				</button>
			</div>
		</div>
	</div>
	<div *ngIf="alarm" class="content-height">
		<div class="sections div1 full-height"
			*ngIf="isCommentBoxShown || isEscalationConfirmationShown || isSendMailBoxShown || isChatShown">
			<div *ngIf="isCommentBoxShown">
				<app-add-comment [comment]="previousComments" (commentAdded)="addComment($event)"
					(commentCancelled)="onCommentCancel()" (commentsChange)="onCommentsTextChange($event)">
				</app-add-comment>
			</div>
			<div *ngIf="isSendMailBoxShown">
				<app-send-mail (sendEmailCancelled)="isSendMailBoxShown=false"></app-send-mail>
			</div>
			<div *ngIf="isEscalationConfirmationShown">
				<app-escalation-confirmation (alarmEscalated)="escalateAlarm()"
					(alarmEscalationCancelled)="isEscalationConfirmationShown=false" [title]="title" [calledFrom]="calledFrom"
					[header]="header"></app-escalation-confirmation>
			</div>
			<!-- Chat Users -->
			<div *ngIf="isChatShown">
				<app-chat-users [alarm]=alarm (ChatBoxCancelled)="isChatShown=false"></app-chat-users>
			</div>
		</div>
		<div class="sections div2 full-height"
			[hidden]="!(!isCommentBoxShown && !isEscalationConfirmationShown && !isSendMailBoxShown && !isChatShown)">
			<div *ngIf="question">
				<app-question [question]="question" [workflowComplete]="workflowComplete"></app-question>
			</div>
		</div>
		<div class="sections div3 full-height" *ngIf="!workflowComplete">
			<div class="heading"> {{ "WORKFLOW.BRANCH_CONTACT" | translate }}</div>
			<ul class="list-group">
				<li *ngFor="let manager of managers">
					<p>{{" " +manager.designation}}</p> <br>
					<p class="manager-name limit-contains" matTooltip="{{manager.name}}">{{manager.name}}</p><br>
					<p>{{ "WORKFLOW.MOBILE" | translate }} : {{manager.contact + " "}}</p>
					<span class="ml-2">
						<i class="fa fa-phone-square" aria-hidden="true"></i>
					</span>
					<hr>
				</li>
			</ul>
		</div>
	</div>
</div>